import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';

export const NotifyBodayCthree = () => {
    const breadcrumbLinks = [       
        { path: '/', label: 'Home' },
        { label: 'Notified Body Transition Details', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Notified Body Transition Details" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />

<section className="service-details section-space">
  <div className="container">
    <div className="row flex-xl-row flex-column-reverse">
      <div className="col-xl-4">
        <div className="sidebar sidebar-rr-sticky">
          <div className="sidebar__widget-service mb-30">
            <Link to="/service">
              Medical Device Manufacturers <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/pharmaceutical-details">
              Pharmaceutical & Biotech industry <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/healthcare-details">
              Healthcare Providers <i className="fa-solid fa-plus"></i>
            </Link>
          </div>

          <div className="sidebar__widget-contact__service text-center">
            <h4 className="mb-25 title-animation text-capitalize">
              Are You ready to contact with us
            </h4>
            <p className="mb-20">
              <a href="tel:+86 19811976744">
                <i className="fa-solid fa-phone"></i>(+86) 19811976744
              </a>
            </p>

            <Link to="/contact-us#" className="rr-btn">
              <span className="btn-wrap">
                <span className="text-one">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
                <span className="text-two">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="col-xl-8">
        <div className="service-details__content">
          <div className="service-details__content-media mb-20">
            <img
              src="./assets/imgs/service-details/service-details-1.jpg"
              className="img-fluid"
              alt="img not found"
            />
          </div>

          <h2 className="title-animation mb-20">Notified Body Transition</h2>

<p className="mb-20">
  We offer a variety of solutions to efficiently manage transition projects. While each transition project is unique, our process remains consistent.
</p>
<h3 className="title-animation mb-20"> Medical Device Registration</h3>

<p className="mb-20">
Medical device registration involves obtaining regulatory approval to market a device in a specific region. This process ensures that the device meets safety, efficacy, and quality standards set by local authorities. Successful registration is crucial for legal market entry and ongoing compliance. 
</p>
        <h4 className="title-animation mb-15">
  How SQUARE MEDTECH Can Help in ROA  Registration
</h4>
<ul className="mb-40">
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Regulatory Compliance Expertise
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Conducting a GAP analysis of your existing technical documentation.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Assisting with planning the required documentation for new products or projects.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Documentation Preparation and Update
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Providing support in creating all necessary technical documentation elements.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Quality Management System (QMS) Integration
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Training and Support
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Cybersecurity and Software Documentation
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Post-Market Surveillance (PMS) and Vigilance Reporting
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Submission and Liaison with Regulatory Bodies
  </li>
</ul>
          {/* Updated section for ROA Registration */}
          <h3 className="title-animation mb-15">
          <i className="fa-solid fa-vial text-primary"></i>   ROA Registration
          </h3>
          <p className="mb-30">
          Medical devices must be registered individually in each country outside of the EU, as each country has its own regulations governing medical devices. Having an EU CE mark or FDA clearance/approval can often simplify these registrations and, in some cases, make the process quite straight forward. Typically, each country requires a local presence, such as an office or an agent, to facilitate the registration process.
          </p>



          <div className="row">
            <div className="col-lg-7">
              <div className="service-details__content-media-item service-details__content-media-item-1">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-2.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15">
                <i class="fa fa-circle-o text-danger"></i> Our Expertise in  ROA registration 
                </h4>
                <p>
                SQUARE MEDTECH specializes in ROA (Regulatory Operational Assessment) registration, ensuring compliance with global regulatory standards. Our expertise covers documentation, submission strategies, and risk assessments, streamlining the approval process. With in-depth knowledge and a proactive approach, we help businesses achieve regulatory compliance efficiently, reducing delays and ensuring market success.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="service-details__content-media-item service-details__content-media-item-2">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-3.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15">
                <i class="fa fa-circle-o text-danger"></i> Why Choose Us for  ROA  registration 
                </h4>
                <p>
                Choose SQUARE MEDTECH for ROA registration for our regulatory expertise, streamlined processes, and commitment to compliance. We ensure efficient submissions, minimizing risks and delays, so you can achieve market approval with confidence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    </main>






<section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Service for Product Registration</h4>
                        <ul  class="color-white mb-0">
                        <li>Post Market Activities</li>
                        <li> Technical Documentation </li>
                        <li>Quality Management System</li>

                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Service for Product Registration</h4>
                        <ul  class="color-white mb-0">
                        <li>QA / RA Service</li>
                        <li>Product Registrations </li>
                        <li>   Digital Health Services</li>
                      </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
